export default __webpack_public_path__ + "static/media/new-relic.75ebc29d.svg";